import React, { Component } from 'react';
import AppRouter from './routers/AppRouter';
import { actionCreators } from './actions/instances';

import {getToken} from './adalConfig';
import { connect } from 'react-redux';
import './App.css';

class App extends Component {

  componentDidMount(){
    this.props.requestInstances();
  }
  
render() {
    return (
      <AppRouter user={this.user} /> 
    );
  }
}

const mapDispatchToProps = (dispatch, props) => ({
  requestInstances: () => dispatch(actionCreators.requestInstances())
});

function mapStateToProps(state) {
  return {
      instances: state.instances.instances
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);




// WEBPACK FOOTER //
// ./src/App.js